import { Input, Button, Form, Radio, Select } from 'antd';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { AppState } from '../../redux/store/rootReducer';
import { addFittingSize, checkDataExist, modifyFittingSize } from './fittingSizeSlice';

export default function AddFittingSize(): JSX.Element {

    const dispatch = useDispatch();
    const fields = useSelector((state: AppState) => state.FittingSizes);
    const BodySizes = useSelector((state: AppState) => state.BodySizes);
    const m_units = useSelector((state: AppState) => state.FittingTypes.MeasuringUnit);
    const { setModelChange, messageApi, editUser, setEditUser } = React.useContext(CommonContext) as CommonContextType;
    // const [body_size, setBodySize] = useState(0);
    const [form_values, setFormValues] = useState<any>({});
    // const [body_size_array, setBodySizeArray] = useState([{}]);
    const [measure_unit_arr, setMeasureUnit] = useState<any>([{}]);
    const [form] = Form.useForm();

    useEffect(() => {

        const arr = m_units.map((el: any) => ({ label: el.unit, value: el.id }))
        setMeasureUnit(arr)

    }, [m_units]);

    useEffect(() => {
        /* if (BodySizes.length > 0) {
            const arr = BodySizes.map((el: any) => ({ value: el.id, label: el.bodysize_value }))
            //   let data = JSON.parse(BodySizes[0].bodysize_value);
            //  const arr = data.map((el: any) => ({ value: JSON.stringify(el), name: JSON.stringify(el) }))
            setBodySizeArray(arr)
        } */
        if (editUser?.id) {/* , { body_sizes: editUser?.body_size?.id } */
            form.setFieldsValue(Object.assign({ measure_units: editUser?.measure_unit?.id }, editUser))
        } else {
            // setBodySize(0)
            setFormValues({})
            form.resetFields();
            // form.setFieldsValue({ layout: 'Inch' })
        }
    }, [editUser, form]);

    const onFinish = (values: any) => {

        // values.body_size = values.body_sizes
        // delete (values.body_sizes)

        values.measure_unit = values.measure_units;
        delete (values.measure_units);
        setFormValues(values)

        dispatch(checkDataExist(values, editUser?.id));
    };
    useEffect(() => {
        if (fields.isProcessingComplete) {
            if (fields.success && form_values?.size_name) {
                if (editUser?.id) {
                    //form type is edit
                    form_values.updated_datetime = new Date().toLocaleString() + "";
                    dispatch(modifyFittingSize(form_values, editUser?.id))
                    /* messageApi.open({
                        type: 'success',
                        content: 'Connection Size updated successfully',
                    }); */
                } else {
                    form_values.created_datetime = new Date().toLocaleString() + "";
                    form_values.updated_datetime = "";
                    dispatch(addFittingSize(form_values))
                    /* messageApi.open({
                        type: 'success',
                        content: 'Connection Size added successfully',
                    }); */
                }
                setModelChange(false)
                setEditUser(null)
                setFormValues({})
                form.resetFields();
            } else {
                messageApi.open({
                    type: 'error',
                    content: 'Connection Size already exist',
                });
            }
        }
    }, [fields])

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return (
        <Form
            form={form}
            layout={'vertical'}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
        >
            {/* <Form.Item label=" "
                name='layout'>
                <Radio.Group>
                    <Radio value="Inch">Inch</Radio>
                    <Radio value="Metric">Metric</Radio>
                </Radio.Group>
            </Form.Item> */}


            <Form.Item
                name='measure_units'
                rules={[
                    {
                        required: true,
                        message: 'Please select unit',
                    },
                ]}>
                <Radio.Group options={measure_unit_arr} />
            </Form.Item>

            <Form.Item label="Size Code"
                name='size_code'
                rules={[
                    {
                        required: true,
                        message: 'Please enter size code',
                    },
                ]}>
                <Input />
            </Form.Item>
            <Form.Item label="Size Name"
                name='size_name'
                rules={[
                    {
                        required: true,
                        message: 'Please enter size name',
                    },
                ]}>
                <Input />
            </Form.Item>
            {/* <Form.Item label="Body Size"
                name='body_sizes'
                rules={[
                    {
                        required: true,
                        message: 'Please select body size',
                    },
                ]}>
                <Select // value={body_size} 
                    options={body_size_array}>
                </Select>
            </Form.Item> */}

            <Form.Item>
                <Button className='submit-button' type="primary" htmlType="submit" >{editUser?.id ? 'Update' : 'Create'}</Button>
            </Form.Item>
        </Form>
    )
}